const listMinimumLimit: Record<string, number> = {
  XRP: 1,
  DOT: 1,
  XLM: 1,
};

export function getMinimumLimitForCurrency(currency: string): number {
  return listMinimumLimit[currency] ?? 0;
}